import { Type } from 'api/report/types';
import { LoadingSpinner } from 'components/interface/LoadingSpinner';
import { NoRows } from 'components/NoRows';
import Timesheet from './timesheet/Timesheet';
import Interval from './interval/Interval';
import { ReportViewProps } from './types';

interface Props extends ReportViewProps {
    type?: Type;
}

export default function Report({ type, ...props }: Props): JSX.Element {
    if (type === undefined) {
        return props.error ? (
            <NoRows
                text='Något gick fel, kontrollera gärna din internetuppkoppling.'
                sx={{ marginTop: 2 }}
                tryAgain
            />
        ) : (
            <LoadingSpinner loading size={75}>
                <></>
            </LoadingSpinner>
        );
    }

    switch (type) {
        case Type.TIMESHEET:
            return <Timesheet {...props} />;
        case Type.INTERVAL:
            return <Interval {...props} />;
        default:
            return <NoRows text='Den här rapporttypen stöds inte ännu.' />;
    }
}
